import ApiService from '../api.service';
import store from '../../store';
import router from '../../router';

const usersService = {
    getUserInfo: async function(userId) {
        try {
            let resp = await ApiService.get('users/getById/' + userId);
            return resp.data;
        } catch (e) {
            console.error(e);
        }
    },
    getUserList: async function(itemsPerPage, currentItem) {
        try {
            let response = await ApiService.post('users/getAllUsers', {
                itemsPerPage,
                currentItem
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getUserListFilter: async function(itemsPerPage, currentItem, filter) {
        try {
            let response = await ApiService.post('users/getAllUsers', {
                itemsPerPage,
                currentItem,
                filter
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    updateIsActive: async function(id, active) {
        try {
            let response = await ApiService.put('users/deactivate', {
                id,
                active
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    deleteUserSession: async function(id) {
        try {
            let response = await ApiService.delete('/users/' + id + '/deleteSessions');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getCurUser: async function() {
        try {
            let response = await ApiService.get('users/currentUser', {});
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    saveUser: async function(
        user_id,
        email,
        name,
        isas_serv_org_rid,
        roles_rid,
        isas_ksk_rid,
        isas_contract_rid,
        category_rid,
        isas_engineer_rid,
        isas_contractor_rid
    ) {
        try {
            let response = await ApiService.post('users/updateUser/' + user_id, {
                email: email,
                name: name,
                isas_serv_org_rid: isas_serv_org_rid,
                roles_rid: roles_rid,
                isas_ksk_rid: isas_ksk_rid,
                isas_contract_rid: isas_contract_rid,
                category_rid: category_rid,
                isas_engineer_rid: isas_engineer_rid,
                isas_contractor_rid: isas_contractor_rid
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    newUser: async function(email, name, isas_serv_org_rid, roles_rid, isas_ksk_rid, isas_contract_rid, category_rid, isas_engineer_rid, isas_contractor_rid) {
        try {
            let response = await ApiService.post('users/create', {
                login: email,
                email: email,
                password: '',
                user_data: {
                    name: name,
                    isas_serv_org_rid: isas_serv_org_rid,
                    roles_rid: roles_rid,
                    isas_ksk_rid: isas_ksk_rid,
                    isas_contract_rid: isas_contract_rid,
                    category_rid: category_rid,
                    isas_engineer_rid: isas_engineer_rid,
                    isas_contractor_rid: isas_contractor_rid
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    signupWithActivation: async function(
        email,
        name,
        isas_serv_org_rid,
        roles_rid,
        isas_ksk_rid,
        isas_contract_rid,
        category_rid,
        isas_engineer_rid,
        isas_contractor_rid
    ) {
        try {
            let response = await ApiService.post('auth/signupWithActivation', {
                login: email,
                email: email,
                password: '',
                userdata: {
                    name: name,
                    isas_serv_org_rid: isas_serv_org_rid,
                    roles_rid: roles_rid,
                    isas_ksk_rid: isas_ksk_rid,
                    isas_contract_rid: isas_contract_rid,
                    category_rid: category_rid,
                    isas_engineer_rid: isas_engineer_rid,
                    isas_contractor_rid: isas_contractor_rid
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export { usersService };
